import { render, staticRenderFns } from "./DealBoardWidget.vue?vue&type=template&id=dda7403e&scoped=true"
import script from "./DealBoardWidget.vue?vue&type=script&lang=js"
export * from "./DealBoardWidget.vue?vue&type=script&lang=js"
import style0 from "./DealBoardWidget.vue?vue&type=style&index=0&id=dda7403e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda7403e",
  null
  
)

/* custom blocks */
import block0 from "./DealBoardWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports